import axios from 'axios'
axios.defaults.baseURL = ''

const http = axios.create({
  // baseURL: 'http://a34.madpay.com/',
  baseURL: 'https://www.jiashengvac.com/',
  // http://admin.jiashengvac.com/
  // baseURL: '/api',
  timeout: 10000, // 请求超时单位 毫秒
  headers: {
    'Content-Type': 'application/json'
  }
})
// 请求拦截
http.interceptors.request.use(config => {
  // 从本地存储或Vuex状态管理获取token
  // const token = localStorage.getItem('token');
  // if (token) {
  //   // 如果token存在，添加到请求头
  //   config.headers.Authorization = `${token}`;
  // }
  return config
})
// 响应拦截
http.interceptors.response.use(config => {
  return config

}, error => {
  return Promise.reject(error)
})

export default http



// WEBPACK FOOTER //
// ./src/utils/reques.js